import React from 'react';
import { CerebroText, CerebroTextProps } from './CerebroText';
import { CerebroLink } from './CerebroLink';

interface CerebroExpandingTextProps extends CerebroTextProps {
	text: string;
	limit: number;
	isHtml: boolean;
}

export const CerebroExpandingText: React.FC<CerebroExpandingTextProps> = ({
	text,
	limit,
	isHtml,
	variant = 'large',
	weight = 'regular',
	component = 'p',
}) => {
	const expandAvailable = text != null && text.length > limit;
	const [expanded, setExpanded] = React.useState<boolean>(!expandAvailable);

	if (text == null || text == undefined || text === '') {
		return <></>;
	}

	const formattedText = isHtml ? removeTags(text) : text;

	return (
		<>
			{expanded && (
				<CerebroText variant={variant} weight={weight} component={component}>
					{formattedText}
					{expandAvailable && (
						<>
							&nbsp;[
							<CerebroLink sx={{ cursor: 'pointer' }} onClick={() => setExpanded(false)}>
								show less
							</CerebroLink>
							]
						</>
					)}
				</CerebroText>
			)}
			{!expanded && (
				<CerebroText variant={variant} weight={weight} component={component}>
					{formattedText.substring(0, limit)}...
					{expandAvailable && (
						<>
							&nbsp;[
							<CerebroLink sx={{ cursor: 'pointer' }} onClick={() => setExpanded(true)}>
								show more
							</CerebroLink>
							]
						</>
					)}
				</CerebroText>
			)}
		</>
	);
};

function removeTags(str: string): string {
	if (!str) {
		return '';
	}
	return str.replace(/(<([^>]+)>)/gi, '');
}
